export {default as Logo} from './Logo'
export {default as Load} from './Load'
export {default as User} from './User'
export {default as RM} from './RM'
export {default as Search} from './Search'
export {default as Bookmark} from './Bookmark'
export {default as BookmarkPlain} from './BookmarkPlain'
export {default as Notification} from './Notification'
export {default as Pdf} from './Pdf'
export {default as ArrowBack} from './ArrowBack'
export {default as Triangle} from './Triangle'
export {default as Upload} from './Upload'
export {default as Alert} from './Alert'
export {default as Arrow} from './Arrow'
export {default as ArrowDrop} from './ArrowDrop'
export {default as Generate} from './Generate'
export {default as Store} from './Store'
export {default as Localisation} from './Localisation'
export {default as Print} from './Print'
export {default as Edit} from './Edit'
export {default as Valid} from './Valid'
export * from './Social'


// WEBPACK FOOTER //
// ./src/components/Shapes/index.js